import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { getProductsByPage } from '../../ApiServices/ProductsService';
import { t } from 'i18next';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  filter: {},
};

const productsSlice = createSlice({
  name: 'products',
  initialState: initialState,
  reducers: {
    clearProductState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.filter = initialState.filter;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProducts.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
      state.filter = action?.meta?.arg;
    });
    builder.addCase(fetchProducts.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
      state.filter = action?.meta?.arg;
    });
    // builder.addCase(fetchProductById.fulfilled, (state: any, action: any) => {
    //   state.error = initialState.error;
    //   state.loading = initialState.loading;
    //   state.selectedValue = action?.payload?.data;
    // });
    // builder.addCase(fetchProductById.rejected, (state: any, action: any) => {
    //   state.loading = initialState.loading;
    //   state.error = action?.payload?.data;
    // });
  },
});

export const productsState = (state: RootState) => state?.products;
export const { clearProductState } = productsSlice.actions;
export default productsSlice.reducer;

export const fetchProducts = createAsyncThunk(
  'products/fetchProducts',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_PRODUCTS') }));
      return fulfillWithValue(await getProductsByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

// export const fetchProductById = createAsyncThunk(
//   'products/fetchProductById',
//   async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
//     try {
//       dispatch(showLoader({ message: t('FETCHING_PRODUCTS_DETAILS') }));
//       return fulfillWithValue(await getProduct(payload));
//     } catch (error) {
//       dispatch(showErrorSnackbar({ message: error }));
//       return rejectWithValue(error);
//     } finally {
//       dispatch(hideLoader());
//     }
//   }
// );
